import React, { useMemo } from 'react';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { TableContainer, Table, TableHead, TableBody, TableCell, TableRow, TablePagination, TableFooter, Paper, Chip, IconButton, Card, Stack, Container } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

export function CustomTable({ tableData, setEditProduct, pagination, setPagination , globalFilter , setGlobalFilter, canAddEdit }) {
    const columns = useMemo(
        () => [
            {
                accessorKey: 'productCode',
                header: 'Product Code',
                size: 100,
            },
            {
                accessorKey: 'productName',
                header: 'Product Name',
                size: 100,
            },
            {
                accessorKey: 'productCategoryName',
                header: 'Product Category',
                size: 100,
                Cell: ({ cell }) => (cell.getValue() === null ? '-' : cell.getValue()),
            },
            {
                accessorKey: 'specialProductCategoryName',
                header: 'Special Product Category',
                size: 100,
                Cell: ({ cell }) => (cell.getValue() === null ? '-' : cell.getValue()),
            },
            {
                accessorKey: 'isActive',
                header: 'IsActive',
                size: 100,
                Cell: ({ cell }) => (cell.getValue() ? <Chip size="small" label="Active" style={{ color: 'green' }} /> : <Chip size="small" label="Inactive" style={{ color: 'red' }} />),
            },
            {
                accessorKey: 'isBOM',
                header: 'IsBOM',
                size: 100,
                Cell: ({ row }) => {
                    const isBOM = row.original?.isBOM;
                    return isBOM ? <Chip size="small" label="Yes" style={{ color: 'green' }} /> : <Chip size="small" label="No" style={{ color: 'red' }} />;
                },
            },
            {
                accessorKey: 'isCutSKU',
                header: 'IsCutSKU',
                size: 100,
                Cell: ({ row }) => {
                    const isCutSKU = row.original?.isCutSKU ;
                    return isCutSKU ? <Chip size="small" label="Yes" style={{ color: 'green' }} /> : <Chip size="small" label="No" style={{ color: 'red' }} />;
                },
            },
            {
                accessorKey: 'action',
                header: 'Action',
                size: 100,
                Cell: ({ row }) => (
                    <IconButton aria-label="edit" disabled={!canAddEdit} onClick={() => EditProduct(row.original.productID)}>
                        <EditIcon />
                    </IconButton>
                ),
            },
        ],
        []
    );

    function EditProduct(productLifeCycleID) {
        setEditProduct(productLifeCycleID)
    }

    const table = useMaterialReactTable({
        columns,
        data: tableData,
    });

    return (
        <div>
            <MaterialReactTable
                columns={columns}
                data={tableData}
                enableFullScreenToggle={false}
                enableHiding={false}
                enableColumnActions={false}
                onPaginationChange={setPagination}
                onGlobalFilterChange = {setGlobalFilter}
                state={{ pagination,globalFilter }}
                initialState={{ density: 'compact', showGlobalFilter: true }}
            />
        </div>
    );
}